<template>
  <div
    class="popup_wrap giftPop"
    style="top: 150px; width:580px;"
  >
    <win-layer-pop class="infoPop">
      <component
        v-if="infoComponent"
        :is="infoComponent"
        @close="closeInfoPopup"
        :parent-info="parentSubInfo"
      />
    </win-layer-pop>
    <button
      class="layer_close"
      @click="$emit('close')"
    >
      close
    </button>
    <form id="mailFrm">
      <div class="popup_cont">
        <h1 class="page_title">{{ $t('msg.COUP100.034') }}</h1>
        <div class="content_box" style="height: 100%;"><!-- content_box -->
          <table id="frm" class="tbl_list" style="border: 0px;">
            <tbody>
              <tr style="height: 40px;">
                <th style="text-align: left; border: 0px; width: 150px; font-size: large; background-color: white; color: black;">{{ $t('msg.COUP100.039') }}</th>
                <td autocomplete="off" style="text-align: left; border: 0px; font-size: large;">{{ couponNm }}<a class="button blue lq" style="font-size: large; margin-left: 20px; float: right;" href="#" @click.prevent="RequestMyCoupon(true)">{{ $t('msg.COUP100.044') }}</a></td> <!-- 신청 -->
              </tr>
              <tr style="height: 40px;">
                <th style="text-align: left; font-size: large; background-color: white; color: black; border-top: 0px;">{{ $t('msg.COUP100.040') }}</th>
                <input autocomplete="off" style="height: 100%; width: 100%; margin-top: 4px; font-size: larger;" :id="`name`" type="text" v-model="params.userName">
              </tr>
              <tr style="height: 40px;">
                <th style="text-align: left; font-size: large; background-color: white; color: black; border-top: 0px;">{{ $t('msg.COUP100.041') }}</th>
                <input autocomplete="off" style="height: 100%; width: 100%; margin-top: 4px; font-size: larger;" :id="`tel`" type="text" v-model="params.userTelNo">
              </tr>
              <tr style="height: 40px;">
                <th style="text-align: left; font-size: large; background-color: white; color: black; border-top: 0px;">{{ $t('msg.COUP100.042') }}</th>
                <input autocomplete="off" style="height: 100%; width: 100%; margin-top: 4px; font-size: larger;" :id="`addr`" type="text" v-model="params.userAddr">
              </tr>
            </tbody>
          </table>
        </div><!-- content_box// -->
        <div style="margin-top: 10px; text-align: center;">
          <input
            id="agreeYn"
            v-model="params.agreeYn"
            type="checkbox"
            true-value="1"
            false-value="0"
          >
          <label for="agreeYn"><h1 style="font-size: large; text-align: center;">{{ $t('msg.COUP100.043') }}</h1></label><h1 href="#" @click.prevent="openInfoPopup('KmtcCouponPersonInfoPop')" style="font-size: large; margin-top: 11px; color: blue; text-decoration: underline; cursor: pointer;">{{ $t('msg.COUP100.062') }}</h1>
        </div>
      </div>
    </form>
  </div>
</template>

<script>

import { rootComputed } from '@/store/helpers'
import schedule from '@/api/rest/schedule/schedule'

export default {
  name: 'KmtcCouponGiftPop',
  components: {
    WinLayerPop: () => import('@/pages/trans/popup/WinLayerPop'),
    KmtcCouponPersonInfoPop: () => import('@/pages/schedule/popup/KmtcCouponPersonInfoPop')
  },
  props: {
    parentInfo: {
      type: Object,
      default: function () {
        return {
          couponNm: '',
          couponNo: '',
          targetNo: ''
        }
      }
    }
  },
  data () {
    return {
      infoComponent: null,
      couponNm: '',
      params: {
        couponNo: '',
        targetNo: '',
        userName: '',
        userTelNo: '',
        userAddr: '',
        agreeYn: 0
      },
      parentSubInfo: {
        userName: ''
      },
      couponRequestList: []
    }
  },
  computed: {
    ...rootComputed
  },
  created () {
    if (this.auth !== undefined) {
      this.lang = this.auth.serviceLang
    }
    this.initParam()

    this.myCouponRequestSearch()
  },
  methods: {
    // init parameter
    async initParam () {
      this.couponNm = this.parentInfo.couponNm
      this.params.couponNo = this.parentInfo.couponNo
      this.params.targetNo = this.parentInfo.targetNo
    },
    async RequestMyCoupon () {
      let chkErr = 0
      let lengthErr = 0

      if (this.params.userName === '') {
        frm.querySelector('#name').style.borderColor = 'red'
        chkErr = 1
      } else {
        frm.querySelector('#name').style.borderColor = ''
      }

      if (this.params.userTelNo === '') {
        frm.querySelector('#tel').style.borderColor = 'red'
        chkErr = 1
      } else {
        frm.querySelector('#tel').style.borderColor = ''
      }

      if (chkErr === 1) {
        this.$ekmtcCommon.asyncAlertMessage({ message: this.$t('msg.COUP100.047') })
        return
      }

      if (this.params.userName.length > 30) {
        frm.querySelector('#name').style.borderColor = 'red'
        lengthErr = 1
      } else {
        frm.querySelector('#name').style.borderColor = ''
      }

      if (this.params.userTelNo.length > 13) {
        frm.querySelector('#tel').style.borderColor = 'red'
        lengthErr = 1
      } else {
        frm.querySelector('#tel').style.borderColor = ''
      }

      if (this.params.userAddr.length > 100) {
        frm.querySelector('#addr').style.borderColor = 'red'
        lengthErr = 1
      } else {
        frm.querySelector('#addr').style.borderColor = ''
      }

      if (lengthErr === 1) {
        this.$ekmtcCommon.asyncAlertMessage({ message: this.$t('msg.COUP100.048') })
        return
      }
      if (this.params.agreeYn !== '1') {
        this.$ekmtcCommon.asyncAlertMessage({ message: this.$t('msg.COUP100.046') })
      } else {
        let obj = {
          alertType: 'normal',
          showXclose: true,
          customCloseBtnClass: 'button blue lg',
          customCloseBtnText: this.$t('cp.COMMON.007'),
          customConfirmBtnText: this.$t('cp.COMMON.006'),
          customConfirmBtnClass: 'button blue lg',
          useConfirmBtn: true,
          title: this.$t('msg.COUP100.044'),
          message: this.$t('msg.COUP100.045'),
          type: 'info'
        }
        if (await this.$ekmtcCommon.asyncAlert(obj)) {
          this.myCouponRequest()
        }
      }
    },
    myCouponRequest: function () {
      schedule.myCouponRequest(this.params).then(() => {
        this.$ekmtcCommon.asyncAlertMessage({ message: this.$t('msg.COUP100.049') })
        this.$emit('close')
      }).catch(err => {
        console.log(err)
      })
    },
    myCouponRequestSearch: function () {
      schedule.getMyCouponRequest(this.params).then(response => {
        this.couponRequestList = response.data

        if (this.couponRequestList.length > 0) {
          this.params.userName = this.couponRequestList[0].cstNm
          this.params.userTelNo = this.couponRequestList[0].cstTelNo

          if (typeof this.couponRequestList[0].cstAddr !== 'undefined') {
            this.params.userAddr = this.couponRequestList[0].cstAddr
          }

          this.params.agreeYn = '1'
        }
      }).catch(err => {
        console.log(err)
      })
    },
    openInfoPopup (compNm) {
      if (this.infoComponent !== null) {
        this.infoComponent = null
        this.$ekmtcCommon.layerClose('.infoPop')
      }
      this.infoComponent = compNm
      this.parentSubInfo.userName = this.params.userName

      this.$ekmtcCommon.layerOpen('.infoPop')
    },
    closeInfoPopup () {
      this.infoComponent = null
      this.$ekmtcCommon.layerClose('.infoPop')
    }
  }
}
</script>

<style scoped>
  .tbl_search th {vertical-align: top;}
  .giftPop > .layer_close {z-index: 10;}
</style>
